module.exports = __webpack_public_path__ + "asset/image-google-play-download-c27eafa6fe12d774.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/google-play-download.png
// module id = tTca
// module chunks = 1